import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    bookingPickupAccordion: {
        ...theme.headings.bookingWidgetSelectsTitle,
        color: theme.colors.white,
    },
    toggleButton: {
        fontFamily: theme.fontFamily,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '0.54px',
        backgroundColor: 'transparent',
        border: 'none',
        color: theme.colors.white,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        width: '100%',
        '& > span:nth-of-type(2) svg': {
            transform: 'rotate(-90deg)',
            transition: `transform ${theme.animations.animate}`,
            marginLeft: 2,
        },
        '&:focus': {
            outline: 'none',
        },
        '&:active': {
            outline: 'none',
        },
    },
    toggleButtonActive: {
        '& > span:nth-of-type(2) svg': {
            transform: 'rotate(90deg)',
        },
    },
    contentVisible: {
        display: 'block',
    },
    contentHidden: {
        display: 'none',
    },
}))

// const BookingPickupAccordion = ({
//   children,
// }) => {
const BookingPickupAccordion = props => {
    const classes = useStyles()
    const [visible, setVisible] = useState(false)

    const contentStyles = visible ? classes.contentVisible : classes.contentHidden
    const buttonStyles = visible
        ? classes.toggleButton
        : `${classes.toggleButton} ${classes.toggleButtonActive}`
    const buttonText = visible
        ? 'Return to Same as Pickup?'
        : 'Select a different Drop Off Location?'
    return (
        <>
            <button
                onClick={() => {
                    setVisible(!visible)
                    props.toggleDropoffLocation(!visible)
                }}
                className={buttonStyles}
            >
                <span>{buttonText}</span>
                <span>
                    <SVG name={'Chevron'} width={12} height={12} colorOne={'#f6c413'} />
                </span>
            </button>
            <div className={contentStyles}>{props.children}</div>
        </>
    )
}

// BookingPickupAccordion.propTypes = {
//   children: PropTypes.oneOfType([
//     PropTypes.string,
//     PropTypes.node
//   ]),
// }

export default BookingPickupAccordion
